import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';

interface IIncident {
  title: string;
  description: string;
  severity: ISeverity;
}

interface ISeverity {
  impact: string;
  message: string;
}

interface ITrafficIncident {
  incidents: IIncident[];
}

export const TrafficIncident = ({ config, modulePath, isDrawer }: IModule<ITrafficIncident>) => {
  return (
    <Tile dataModule="traffic-incident" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2 config={config} isDrawer={isDrawer} modulePath={modulePath} />
        <div className="TrafficIncidents">
          <ul className="TrafficIncidents-list">
            {config.incidents.map(({ title, description, severity: { message } }) => (
              <li className="TrafficIncidents-listItem" key={title}>
                <p className="TrafficIncidents-location h2">{title}</p>
                <p className="TrafficIncidents-advisory h2">{message}</p>
                <p className="TrafficIncidents-detail">{description}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Tile>
  );
};
